import React, { useMemo } from 'react'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import Progress from 'core/components/progress/Progress'
import { formatDate } from 'utils/misc'
import SimpleLink from 'core/components/SimpleLink'
import { routeManager } from 'core/utils/routes'
import { humanReadableSize } from 'app/plugins/openstack/helpers'
import useListAction from 'core/hooks/useListAction'
import { useSelector } from 'react-redux'
import { listVolumes } from '../../volumes/actions'
import { volumesByIdSelector } from '../../volumes/selectors'
import { IVolumeDetailsPageTabs } from '../../volumes/volume-details/model'
import OverviewCard from 'openstack/components/vms/vm-details/OverviewCard'
import { StatusCellComponent } from '../VolumeSnapshotsListPage'

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  overview: {
    display: 'grid',
    gridTemplateColumns: '370px 1fr',
    marginTop: '16px',
    gridGap: '24px',
  },
  column: {
    display: 'grid',
    gridGap: '24px',
    gridAutoFlow: 'row',
    gridAutoRows: 'max-content',
  },
}))

export default function Overview({ snapshot, loading }) {
  const classes = useStyles({})

  const { loading: loadingVolumes } = useListAction(listVolumes)
  const volumesById = useSelector(volumesByIdSelector)

  const overviewData = useMemo(
    () =>
      snapshot
        ? [
            {
              key: 'Name',
              value: snapshot?.name,
            },
            {
              key: 'ID',
              value: snapshot?.id,
            },
            {
              key: 'Description',
              value: snapshot?.description,
            },
            {
              key: 'Status',
              value: snapshot?.status,
              render: (val) => <StatusCellComponent value={snapshot?.status} item={val} />,
            },
            {
              key: 'Size',
              value: snapshot?.size,
              render: ({ size }) => humanReadableSize(size * 1024 * 1024 * 1024),
            },
            {
              key: 'Source Volume',
              value: snapshot?.volume_id,
              render: ({ volume_id }) => (
                <SimpleLink
                  src={routeManager.routes.openstack.volumeDetails.path({
                    id: volume_id,
                    tab: IVolumeDetailsPageTabs.Overview,
                  })}
                >
                  {volumesById?.[volume_id]?.name || volume_id}
                </SimpleLink>
              ),
            },
            {
              key: 'Created',
              value: snapshot?.created_at,
              render: ({ created_at }) => formatDate(created_at),
            },
          ]
        : [],
    [volumesById],
  )

  return (
    <Progress loading={loading}>
      <div className={classes.overview}>
        <div className={classes.column}>
          <OverviewCard item={snapshot} data={overviewData} icon="coins" />
        </div>
      </div>
    </Progress>
  )
}
